export default __webpack_public_path__ + "static/BrownEntrataTT-Regular-b21547d91b157913da30c1722a1ff95b.ttf";